/* ==========================================================================
   FOOTER
   ========================================================================== */

function footerHeight() {
  const footer = document.querySelector<HTMLElement>("#footer");
  var body = document.querySelector<HTMLElement>("body");
  if (!footer || !body) return;
  body.style.setProperty("--footer-height", footer.clientHeight + "px");
}

window.addEventListener("load", function () {
  footerHeight();
});

window.addEventListener("resize", function () {
  footerHeight();
});
